import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
  formControl: {
    width: '100%',
    paddingBottom: 20,
  },
});

const MultipleChoice = ({classes, handler, question, value}) => {
  return (
    <Grid item xs={12}>
      <FormControl className={classes.formControl}>
        <FormLabel component="legend">{question.text}</FormLabel>
        <FormGroup>
          {question.answerOptions.map(answerOption => (
            <FormControlLabel
              key={answerOption.id}
              control={<Checkbox checked={value && value.includes(answerOption.id)} />}
              onChange={() => handler(question.id, answerOption.id, question.questionType)} label={answerOption.text}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Grid>
  );
};

export default withStyles(styles)(MultipleChoice);
